import { useParams } from 'react-router-dom'

import Paper from '@/components/Paper'
import { getServiceAlerts } from '@/modules/Service/services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import AlertHistory from './History'
import Threshold from './Threshold'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Alerts = () => {
    const { id: serviceID } = useParams()
    const { data, renderState } = useQueryWithHandler({
        queryFn: () => getServiceAlerts(Number(serviceID)),
        queryKey: [QUERY_KEYS.SERVICES_ALERTS, Number(serviceID)],
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <Paper className="space-y-2 mt-2">
            <div className="xs:space-y-2 md:space-x-2 flex flex-col md:flex-row">
                <div className="xs:w-full md:w-1/2">
                    <Threshold alerts={data?.results} />
                </div>
                <div className="xs:w-full md:w-1/2">
                    <AlertHistory />
                </div>
            </div>
        </Paper>
    )
}

export default Alerts
